// extracted by mini-css-extract-plugin
export default {"background":"HelpPage_background__UZIX8"};